export const CONTENT_GUTTER_CLASSES = "px-8";
export const CONTENT_TOP_CLASSES = "pt-5";
export const CONTENT_BOTTOM_CLASSES = "pb-10";
export const CONTENT_CLASSES_WITH_TOP_HEADER = `${CONTENT_BOTTOM_CLASSES} ${CONTENT_GUTTER_CLASSES} ${CONTENT_TOP_CLASSES}`;
export const DEFAULT_EXPANDED_SIDE_NAV = true;
export const SIDEBAR_EXPANDED_KEY = "sidebar_expanded";
